<template>
  <div class="rolld-nav">
    <div class="header">
      <div class="row">
        <div class="logo">
          <a href="https://rolld.com.au"
            ><img src="../assets/rolld/Rolld_Logo-1.png" />
          </a>
        </div>
        <ul>
          <li><a href="https://rolld.com.au/find-rolld/">Find Roll’d</a></li>
          <li><a href="https://rolld.com.au/franchise/">Franchise</a></li>
          <li><a href="https://rolld.com.au/rolld-app/">Roll’d App</a></li>
          <li><a href="https://rolld.com.au/news/">News</a></li>
          <li><a href="https://rolld.com.au/careers/">Careers</a></li>
        </ul>
        <div class="menu">
          <!-- <div class="order-now">
            <a href="https://rolldvietnamese.orderup.com.au/"
              ><span>Order Now</span></a
            >
          </div>
          <span @click="showPupop = true" class="material-icons md-36"
            >menu</span
          > -->
        </div>
      </div>
    </div>

    <div v-show="showPupop" class="menu-pupop">
      <div class="pupop-container">
        <div class="pupop-header">
          <ul>
            <li>
              <a href="https://rolld.com.au/menu/">Menu</a>
            </li>
            <li><a href="https://rolld.com.au/find-rolld/">Find Roll`d</a></li>
            <li><a href="https://rolld.com.au/franchise/">Franchise</a></li>
            <li><a href="https://rolld.com.au/rolld-app/">Roll`d App</a></li>
            <li><a href="https://rolld.com.au/news/">News</a></li>
            <li><a href="https://rolld.com.au/careers/">Careers</a></li>
          </ul>
          <div class="close-menu">
            <span @click="showPupop = false" class="material-icons md-36"
              >close</span
            >
          </div>
        </div>
        <div class="pupop-search">
          <form role="search" action="https://rolld.com.au" method="get">
            <div class="d-flex">
              <div class="search-icon">
                <img src="../assets/rolld/search-icon.png" />
              </div>
              <input
                placeholder="Search"
                type="search"
                name="s"
                title="Search"
                value=""
              />
            </div>
          </form>
        </div>
        <div class="pupop-menus">
          <div class="col-custom-20">
            <h4>Food</h4>
            <ul>
              <li>
                <a href="https://rolld.com.au/menu/">Menu</a>
              </li>
              <li>
                <a href="https://rolld.com.au/find-rolld/">Locations</a>
              </li>
              <li>
                <a href="https://rolld.com.au/catering/">Catering</a>
              </li>
              <li>
                <a href="https://rolld.com.au/meal-boxes/">Meal Boxes</a>
              </li>
              <li>
                <a href="https://rolld.com.au/products/">Our Products</a>
              </li>
            </ul>
          </div>
          <div class="col-custom-20">
            <h4>Brand</h4>
            <ul>
              <li><a href="https://rolld.com.au/news/">News</a></li>
              <li><a href="https://rolld.com.au/our-story/">Our Story</a></li>
              <li>
                <a href="https://rolld.com.au/partnerships/">Partnerships</a>
              </li>
              <li><a href="https://rolld.com.au/rolld-app/">Roll’d App</a></li>
              <li><a href="https://rolld.com.au/charity/">Social Impact</a></li>
            </ul>
          </div>
          <div class="col-custom-20">
            <h4>franchise</h4>
            <ul>
              <li><a href="https://rolld.com.au/franchise/">Franchise</a></li>
              <li>
                <a href="https://rolld.com.au/franchise-event/"
                  >Franchise Events</a
                >
              </li>
              <li>
                <a href="https://rolld.com.au/franchise-opportunities/"
                  >Franchise International</a
                >
              </li>
              <li>
                <a href="https://rolld.com.au/franchise/#ready-to-id"
                  >Contact</a
                >
              </li>
            </ul>
          </div>
          <div class="col-custom-20">
            <h4>contact</h4>
            <ul>
              <li><a href="https://rolld.com.au/careers/">Careers</a></li>
              <li><a href="https://rolld.com.au/faqs/">FAQs</a></li>
              <li><a href="https://rolld.com.au/contact/">Contact</a></li>
            </ul>
          </div>
          <div class="col-custom-20">
            <h4>social</h4>
            <ul>
              <li>
                <a
                  href="https://instagram.com/rolld_vietnamese/"
                  target="_blank"
                >
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/rolld.australia"
                  target="_blank"
                  rel="nofollow"
                >
                  <span>Facebook</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UC3CFtjBfeF_0AhwVkPXyI_w"
                  target="_blank"
                  rel="nofollow"
                >
                  <span>YouTube</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/rolld-australia-pty-ltd/"
                  target="_blank"
                  rel="nofollow"
                >
                  <span>LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPupop: false,
    };
  },
  computed: {
    bodyStyle() {
      return [];
    },
    widthStyle() {
      return [{ "max-width": this.width }];
    },
  },
};
</script>
